export default __webpack_public_path__ + "static/media/ic_btc_24.55d3e96d.svg";